import FormattedMessage from 'I18n/components/FormattedMessage';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { BreezeLoadingDot } from 'ai-components-ui-library/components/loading/BreezeLoadingDot';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { ErrorBoundary } from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import useCloneTracker from '../../../../../../hooks/useCloneTracker';
import { updateReportWithAIPromptReportResult } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HOVER_REPORT_PREVIEW_WIDTH = '400px';
const MAX_TOOLTIP_WIDTH = '1000px';
const MAX_TOOLTIP_HEIGHT = '1000px';
const RefreshRemixContent = () => /*#__PURE__*/_jsxs(Text, {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-enablement.singleReportViewer.AIReportSummary.reportRemixes.error"
  }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-enablement.singleReportViewer.AIReportSummary.reportRemixes.errorCta"
  })]
});
const AIReportRemixPills = ({
  appUsageTracker,
  report,
  onChange,
  selectedPresetId,
  setSelectedPresetId,
  aiReportPresetFetch
}) => {
  const tracker = useCloneTracker(appUsageTracker);
  if (!isConfigReport(report)) {
    return null;
  } else if (isLoading(aiReportPresetFetch)) {
    return /*#__PURE__*/_jsx(View, {
      display: "inline-block",
      children: /*#__PURE__*/_jsx(BreezeLoadingDot, {})
    });
  } else if (isSucceeded(aiReportPresetFetch)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      ErrorComponent: RefreshRemixContent,
      children: Object.keys(aiReportPresetFetch.data.reportRemixGenerationConfigs).map(remixId => {
        const promptReportObject = aiReportPresetFetch.data.reportRemixGenerationConfigs[remixId];
        const TooltipContent = () => /*#__PURE__*/_jsx(View, {
          inlineSize: HOVER_REPORT_PREVIEW_WIDTH,
          children: /*#__PURE__*/_jsx(PlatformReportResolver, {
            report: updateReportWithAIPromptReportResult(report, promptReportObject),
            useInlineLabels: false,
            allowDrilldown: false
          })
        });
        return /*#__PURE__*/_jsx(Tooltip, {
          use: "longform",
          Content: TooltipContent,
          maxInlineSize: MAX_TOOLTIP_WIDTH,
          maxBlockSize: MAX_TOOLTIP_HEIGHT,
          children: /*#__PURE__*/_jsx(View, {
            margin: "0",
            children: /*#__PURE__*/_jsx(AIButton, {
              size: "extra-small",
              use: selectedPresetId === remixId ? 'primary' : 'secondary',
              onClick: () => {
                setSelectedPresetId(remixId);
                onChange(updateReportWithAIPromptReportResult(report, promptReportObject), {
                  isReportRemixChange: true
                });
              },
              usageTracker: tracker,
              children: promptReportObject.reportTitle
            })
          })
        }, remixId);
      })
    });
  }
  return /*#__PURE__*/_jsx(RefreshRemixContent, {});
};
export default AIReportRemixPills;